import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import abut3 from "../../images/about/img-3.jpg"

const ClickHandler = () => {
    window.scrollTo(10, 0)
}

const AboutSection3 = () => {
     
  const iframeRef = useRef(null);
    const [muted, setMuted] = useState(true);

    const toggleMute = () => {
        const iframe = iframeRef.current;

        iframe.contentWindow.postMessage(
            JSON.stringify({
                event: "command",
                func: muted ? "unMute" : "mute",
            }),
            "*"
        );
                setMuted(!muted);
    };

    return (
        <section className="wpo-about-section-s3 section-padding">
            <div className="container">
                <div className="wpo-about-wrap">
                    <div className="row align-items-center">
                      <div className="col-lg-6 col-md-12 col-12">
                            <div className="wpo-about-img-s3">
                                <div className="image">
                                    <img src={abut3} alt="" />
                                    {/* <div className="shape">
                                        <img src={abutShape3} alt="" />
                                    </div> */}
                                </div>
                        </div>
                    </div>
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="wpo-about-text">
                                 <div className="wpo-section-title">
                                    {/* <span>Welcome to Heart-to-Heart Children Aid</span> */}
                                    <h2>Saving Children’s Hearts Together</h2>
                                </div>
                                                               <p>Heart-to-Heart Children Aid was founded out of a deep belief that every heartbeat matters. 
We are a committed humanitarian organization providing free heart surgeries for children 
who cannot afford life-saving care. Our journey began in Ethiopia, where our founder and 
owner of Ethio-Istanbul General Hospital, Mr. Birhan Tedla, personally sponsored 114
children's surgeries (ranging from PDA repair to multi valve replacement procedures). Today, we work from Washington, D.C., and 
Addis Ababa to reach children across the world. Join our mission to give children the 
opportunity to live, learn, and play, as we strive to save 1000 lives every year.</p>

                                <div className="about-btn">
                                    <Link to="/about" className="theme-btn" onClick={ClickHandler}>Discover More</Link>
                                    {/* <a href="tel:+4733378901" className="call-content">
                                        <div className="icon">
                                            <i className="flaticon-phone-call"></i>
                                        </div>
                                        <div className="text">
                                            <h5>Call Us:</h5>
                                            <span>+(684) 555-0102</span>
                                        </div>
                                    </a> */}
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default AboutSection3;